import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { disableUserSelect } from 'src/styles/styles';

import { colors } from '../../../styles/colors';
import { ZeeFontBold } from '../../../styles/font';
import { MediaBP as MQ } from '../../../styles/mediaQuery';
import { flex } from '../../../styles/utils';

export const menuGroup = css`
  ${disableUserSelect};
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: ${colors.PrimaryWhiteColorAlpha40};
  border-top: 2px solid ${colors.PrimaryWhiteColorAlpha10};
`;

export const slideDown = css`
  @keyframes slideDown {
    from {
      transform: translateY(-50%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  animation-duration: 0.1s;
  animation-name: slideDown;
`;

export const slideUp = css`
  @keyframes slideUp {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(-100%);
      opacity: 0;
    }
  }
  animation-duration: 0.1s;
  animation-name: slideUp;
`;

export const ChevronUp = css`
  transform: rotate(180deg);
  transition: 0.2s;
`;

export const ChevronDown = css`
  transform: rotate(0deg);
  transition: 0.2s;
`;

export const activeItem = css`
  background-color: ${colors.PrimaryWhiteColorAlpha05};
`;

export const menuTitle = css`
  ${ZeeFontBold(14, 18)};
  color: ${colors.PrimaryWhiteColorAlpha50};
  padding: 16px 32px;
  width: 100%;
  ${flex('row', 'space-between', 'center')};
`;

export const NewOption = styled.div`
  height: 10px;
  display: inline-block;
  margin-left: 4px;
  border-radius: 50%;
  background-color: ${colors.NewOptionOrange};
  width: 10px;
`;

export const menuItemStyle = (name: string) => css`
  display: block;
  padding: 15.5px 16px;
  ${disableUserSelect}
  margin: 0px 16px;
  border-radius: 8px;
  ${ZeeFontBold(14, 18)};
  ${disableUserSelect};
  color: ${colors.white};
  :last-child {
    ${name === ''
      ? ``
      : `
      margin-bottom: 16px;
    `};
  }
  &:hover {
    background-color: ${colors.PrimaryWhiteColorAlpha05};
  }
  ${MQ.MediaLg} {
    ${name === ''
      ? `
      margin: 16px;
    `
      : ``};
  }
`;
